function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  id: "Browser",
  className: "cls-1",
  d: "M2.075.822A2.074,2.074,0,0,0,0,2.9v8.533a1.757,1.757,0,0,0,1.756,1.75H12.244A1.748,1.748,0,0,0,14,11.429V2.9A2.074,2.074,0,0,0,11.927.825ZM12.242,10.29A1.206,1.206,0,0,1,11.035,11.5H2.965A1.206,1.206,0,0,1,1.758,10.29V6.035A1.206,1.206,0,0,1,2.965,4.828h8.07a1.206,1.206,0,0,1,1.207,1.207Z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "BeBold",
    viewBox: "0 0 14 14"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/laptop.7abe9a14.svg";
export { SvgComponent as ReactComponent };